import { Type, type Static } from '@sinclair/typebox';
import { StringEnum } from '../../utils/typebox';

export const minimalUserSchema = {
  id: Type.String({
    description: 'Unique identifier of the user for the provider. Usually an internal identifier used by the API only.',
  }),
  object: Type.Literal('User'),
  type: StringEnum(['individual', 'organization', 'other'], {
    description: `Type of the user
      - \`individual\` is an individual user.
      - \`organization\` is an organization / business entity.
      - \`other\` is an other type of entity.`,
  }),
  public_identifier: Type.Optional(
    Type.String({
      description: 'Public identifier of the user for the provider. Usually a shareable tag visible in urls and profiles. ',
    }),
  ),
  display_name: Type.String({
    description: 'Display name of the user as exposed by the provider.',
  }),
  first_name: Type.Optional(Type.String({ description: 'First name of the user.' })),
  last_name: Type.Optional(Type.String({ description: 'Last name of the user.' })),
  profile_url: Type.Optional(Type.String({ format: 'uri', description: 'Public url to the profile of the user.' })),
  public_picture_url: Type.Optional(
    Type.String({ format: 'uri', description: 'Public url to the profile picture of the user.' }),
  ),
  private_picture_download_url: Type.Optional(
    Type.String({
      format: 'uri',
      description: 'Private url to download the profile picture of the user. This url require authentication.',
    }),
  ),
  description: Type.Optional(Type.String({ description: 'Description of the user.' })),
  specifics: Type.Optional(
    Type.Any({
      description: 'Provider-specific user data.',
    }),
  ),
};

export const minimalUserSchemaObj = Type.Object(minimalUserSchema);

export type MinimalUser<Specifics = unknown> = Omit<Static<typeof minimalUserSchemaObj>, 'specifics'> & {
  specifics?: Specifics;
};
